const isObject = (value) => Object.prototype.toString.call(value) === '[object Object]'
export const state = () => {
  return {}
}
export const mutations = {
  setRegionOption(state, data) {
    state.regionOption = data
  },
  update(state, payload) {
    Object.keys(payload).forEach((k) => {
      //   console.log('base/update', state[k], payload[k])
      if (isObject(payload[k])) {
        if (payload[k]) {
          state[k] = Object.assign(state[k], payload[k])
        }
      } else if (payload[k]) {
        state[k] = payload[k]
      }
    })
  },
}
export const actions = {}
export const getters = {}
